// services.js
import { viewId, table, restApiKey } from '../../../../_constants/Code'
import { getDynamoDB } from '../../../../common/utils/DynamoDbUtils'
import { errorLog } from '../../../../common/logger/Logger'
import { PathInfoList } from '../../../../_constants/PathInfoList'
import { httpPost } from '../../../../services/api/AmplifyApi'
import { getIndustrySector } from '../../../../common/utils/FileUtils'

/**
 * Fetch master data for a company
 *
 * @param {string} corporationNumber
 * @param {string} userId
 * @returns {Promise<Object | null>}
 */
export const fetchMasterData = async (corporationNumber, userId) => {
  try {
    const masterData = await getDynamoDB(
      table.Master,
      null,
      corporationNumber,
      { CorporationNumber: corporationNumber, MasterId: viewId.companyInfo },
      null
    )
    return masterData[0] || null
  } catch (error) {
    errorLog('E000001', userId, viewId.companyInfo, 'fetchMasterData', error)
    return null
  }
}

/**
 * Fetch company data
 *
 * @param {string} corporationNumber
 * @param {string} userId
 * @returns {Promise<Object | null>}
 */
export const fetchCompanyData = async (corporationNumber, userId) => {
  try {
    const data = await getDynamoDB(
      table.Company,
      null,
      corporationNumber,
      { CorporationNumber: corporationNumber },
      null
    )
    return data[0] || null
  } catch (error) {
    errorLog('E000002', userId, viewId.companyInfo, 'fetchCompanyData', error)
    return null
  }
}
/**
 * Update company info API
 *
 * @param {string} corporationNumber
 * @param {Object} body
 * @param {string} userId
 * @returns {Promise<Object | null>}
 */
export const updateCompanyInfoApi = async (corporationNumber, body, userId) => {
  try {
    const res = await httpPost(restApiKey.CHROFY_REST_API, PathInfoList.Resource.updateCompanyInfo(corporationNumber), {
      headers: {},
      body
    })
    return res
  } catch (error) {
    errorLog('E000003', userId, viewId.companyInfo, 'updateCompanyInfoApi', error)
    return null
  }
}

// services.js

/**
 * 業種マスターデータ取得処理
 *
 * S3に保存されている業種マスタデータを取得し、 親子関係（親業種・子業種）を考慮したリスト形式に変換して返却する。
 *
 * @param {string} corporationNumber 法人番号
 * @param {string} userId ユーザーID（エラーログ出力用）
 * @returns {Promise<Array>} 業種マスタリスト
 */
export const fetchIndustrySectorData = async (corporationNumber, userId) => {
  try {
    const s3Data = await getIndustrySector(corporationNumber, '1')

    s3Data.sort((a, b) => (a.CorporationName > b.CorporationName ? 1 : a.CorporationName < b.CorporationName ? -1 : 0))

    const newList = []
    s3Data.forEach((item) => {
      const newItem = { key: item.Key, name: item.Name }
      if (item.SuperKey !== null) {
        const parentItem = newList.find((p) => p.key === item.SuperKey)
        if (parentItem) {
          if (!parentItem.list) parentItem.list = []
          parentItem.list.push(newItem)
        }
      } else {
        newList.push(newItem)
      }
    })

    return newList
  } catch (error) {
    errorLog('E000001', userId, viewId.companyInfo, 'fetchIndustrySectorData', error)
    return []
  }
}
